import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=473e2c09&"
import script from "./PerPage.vue?vue&type=script&lang=js&"
export * from "./PerPage.vue?vue&type=script&lang=js&"
import style0 from "./PerPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports